import screenerConfig from 'screenerConfig';

export const DEFAULT_SEARCH_PARAMETERS_CONFIG = screenerConfig.defaultSearchParametersConfig;
